<template>
  <div class="message-main-container">
    <slot name="messageDetail">
      <div class="message-detail-container"></div>
    </slot>
    <slot name="message"></slot>
  </div>
</template>

<script>
export default {
  name: "MessageContainer"
};
</script>

<style lang="scss"></style>
